export const invoicesMisc = {
  sendLink: {
    title: "Rechnungslink senden",
    already: {
      title: "Für diese Buchung wurde bereits eine Rechnung ausgestellt.",
      onlyOne: "Es ist nur <b>1 Rechnung pro Buchung</b> zulässig.",
      offerPdf:
        "Wenn Sie möchten, senden wir Ihnen die Rechnung als PDF sofort über WhatsApp.",
    },
    openPdf: "PDF öffnen",
    sendWhatsapp: "Rechnung über WhatsApp senden",
    sending: "Wird gesendet...",
    info: {
      title: "Der Rechnungslink wird dem Gast über WhatsApp gesendet.",
      desc: "Der Gast ergänzt seine Steuerdaten über den Link und kann seine elektronische Rechnung herunterladen.",
    },
    rule: "<strong>Regel:</strong> Es kann nur <b>1 Rechnung pro Buchung</b> ausgestellt werden.",
    accept: "Akzeptieren und senden",
    toast: {
      invoiceSent: "Rechnung über WhatsApp gesendet.",
      linkSent: "Rechnungslink über WhatsApp gesendet.",
    },
    warn: {
      noReservation: "Die Buchungs-ID wurde noch nicht gefunden.",
    },
    err: {
      sendInvoiceFailed: "Die Rechnung konnte nicht über WhatsApp gesendet werden.",
      sendLinkFailed: "Der Link konnte nicht gesendet werden.",
    },
  },
  country: {
    placeholder: "Land auswählen (optional)",
    noResult: "Keine Ergebnisse",
  },
  adjust: {
    title: "{name} anpassen",
    type: {
      apartment: "Apartment(s)",
      hotel: "Hotel (Zimmer)",
      villa: "Villen",
      camping: "Stellplätze",
      default: "Unterkünfte",
    },
    usage: "Aktuelle Nutzung",
    available: "Verfügbar",
    unitDefault: "Einheiten",
    hintReduce:
      "Die Reduzierung gilt ab sofort und führt <b>nicht</b> zu einer Rückerstattung. Sie zahlen bei der nächsten Rechnung weniger.",
    unitPriceCurrent: "Aktueller Stückpreis",
    totalBeforeProration: "Gesamt (vor anteiliger Berechnung)",
    prorationNote:
      "Für die bereits vergangenen Tage des Zyklus wird eine <b>anteilige Berechnung</b> angewendet.",
    confirmIncrease: "Erhöhung bestätigen",
    confirmDecrease: "Reduzierung bestätigen",
    err: {
      selectAmount: "Wählen Sie eine Menge zum Anpassen aus.",
      failed: "Der Vorgang konnte nicht abgeschlossen werden.",
    },
    toast: {
      added: "Einheiten hinzugefügt",
      reduced: "Einheiten reduziert",
      addedDetail: "Für die verbleibenden Tage des Zyklus wird eine anteilige Berechnung angewendet.",
      reducedDetail: "Sie zahlen bei der nächsten Rechnung weniger (keine Rückerstattung).",
    },
  },
  menu: {
    title: "Mein Abonnement",
    subtitle: "Verwalten Sie Ihre Abonnements, Rechnungen und Zahlungsmethoden",
    subscription: "Mein Abonnement",
    paymentMethod: "Zahlungsmethode",
    invoices: "Rechnungen",
  },
  custom: {
    title: "Individueller Tarif",
    whatDoYouNeed: "Was benötigen Sie?",
    salesContact:
      "Unser Vertriebsteam meldet sich so schnell wie möglich bei Ihnen.",
    tellUs: "Erzählen Sie uns mehr über Ihr Projekt",
    sentOk: "Erfolgreich gesendet",
    salesContactShort:
      "Das Vertriebsteam meldet sich so schnell wie möglich",
    contactSales: "Vertrieb kontaktieren",
    err: {
      required:
        "Sie müssen angeben, was Sie benötigen, damit wir uns bei Ihnen melden können",
      failed: "Die Anfrage konnte leider nicht bearbeitet werden",
    },
  },
  common: {
    cancel: "Abbrechen",
    close: "Schließen",
  },
};
